import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ZoneProtegee from "./components/ZoneProtegee";
import { useAIStudioStore } from "./store/useAIStudioStore";
import "./styles/globals.css";

// Log la version build au demarrage. L'user peut ouvrir la console pour
// verifier quelle version est servie en prod et confirmer qu'un deploiement
// recent est bien chargé (vs un cache obsolète).
// __APP_COMMIT__ et __APP_BUILD_DATE__ sont injectes par vite.config.js
// au build time.
// eslint-disable-next-line no-console
console.log(
  `%c🏷️ LabelForge%c build ${__APP_COMMIT__} · ${__APP_BUILD_DATE__}`,
  "color:#fbbf24;font-weight:bold;font-size:13px",
  "color:#9ca3af;font-family:monospace;font-size:11px"
);

// Fichiers JS périmés après un déploiement. Chaque fusion dans `main` redéploie,
// et les fichiers du déploiement précédent disparaissent : Vercel renvoie la page
// HTML à leur place (mesuré le 2026-10-04 sur deux vrais fichiers de la veille).
// Un onglet ouvert AVANT la fusion ne peut donc plus ouvrir un panneau chargé à la
// demande (Studio IA, Guide, Présentation…). Vite le signale par cet évènement,
// juste avant que l'erreur ne remonte jusqu'à la ZoneProtegee du panneau.
//
// On ne RETIENT jamais l'erreur (pas d'`event.preventDefault()`), même quand on
// recharge : retenue, Vite fait résoudre l'import sur `undefined`, et React.lazy
// lève alors une erreur trompeuse (« reading 'default' ») que la ZoneProtegee
// présente comme une panne. Laissée passer, elle affiche le bon message — « Une
// nouvelle version est en ligne » — le temps que la page recharge. Vu au banc le
// 2026-10-04, en servant une version pendant qu'une autre était ouverte.
const CLE_RECHARGEMENT = "labelforge:rechargement-version";
window.addEventListener("vite:preloadError", () => {
  // Anti-boucle : si on a déjà rechargé pour cette raison il y a moins d'une
  // minute, le fichier manque pour une AUTRE raison qu'une nouvelle version.
  let dernier = 0;
  try { dernier = Number(sessionStorage.getItem(CLE_RECHARGEMENT)) || 0; } catch { /* navigation privée */ }
  const dejaRecharge = Date.now() - dernier < 60_000;

  // Un travail IA en cours : son enregistrement en galerie est fait par CETTE
  // page à la fin du travail, et `currentJobId` n'est pas persisté — recharger
  // maintenant perdrait l'image. Même chose pour la file de détourage par lot.
  const studio = useAIStudioStore.getState();
  const travailEnCours = Boolean(studio.currentJobId)
    || (studio.cutout?.fichiers ?? []).some((f) => f.etat === "attente" || f.etat === "cours");

  // Recharger tout seul seulement quand c'est sans risque. Sinon, la ZoneProtegee
  // propose le rechargement : l'utilisateur choisit son moment.
  if (!dejaRecharge && !travailEnCours) {
    try { sessionStorage.setItem(CLE_RECHARGEMENT, String(Date.now())); } catch { /* navigation privée */ }
    window.location.reload();
  }
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {/* Dernier filet : une panne hors des zones de l'éditeur (pages de connexion,
        barre du haut…) affiche ceci au lieu d'un écran noir. */}
    <ZoneProtegee nom="LabelForge" className="h-screen w-screen bg-forge-bg">
      <App />
    </ZoneProtegee>
  </React.StrictMode>,
);
